import { apolloClient } from '~/apollo-client';
import { BillingDataSource, EnrollmentDataSource } from '~/typings/context';
import {
  EnrollmentOptionName,
  Flex_FetchBillingExperienceOptionsQuery,
  Flex_FetchBillingExperienceOptionsQueryVariables,
} from '~/typings/graphql';
import { FETCH_BILLING_EXPERIENCE_OPTIONS } from './fetch-billing-experience-options.queries';

// higher == more preferential
const preference: Record<BillingDataSource, number> = {
  acb: 4,
  dual: 3,
  ucb: 2,
  none: 1,
};

export const fetchBillingExperienceOptions = async (
  params: FetchBillingExperienceOptionsParams,
): Promise<FetchBillingExperienceOptionsResponse> => {
  if (!params.enrollmentDataSourceName) {
    return { billingExperienceOptions: [] };
  }
  const { data } = await apolloClient.query<
    Flex_FetchBillingExperienceOptionsQuery,
    Flex_FetchBillingExperienceOptionsQueryVariables
  >({
    query: FETCH_BILLING_EXPERIENCE_OPTIONS,
    variables: {
      utilityId: params.utilityId,
      enrollmentDataSourceName: params.enrollmentDataSourceName as EnrollmentOptionName,
      communitySolarProjectGroupId: params.communitySolarProjectGroupId,
    },
  });

  const billingExperienceOptions = data.billingExperienceOptions
    .map(option => option.name as BillingDataSource)
    .sort((a, b) => (preference[b] || 0) - (preference[a] || 0));

  if (params.preference && billingExperienceOptions.includes(params.preference)) {
    return { billingExperienceOptions: [params.preference] };
  } else if (params.limit) {
    return { billingExperienceOptions: billingExperienceOptions.slice(0, params.limit) };
  } else {
    return { billingExperienceOptions };
  }
};

export interface FetchBillingExperienceOptionsParams {
  enrollmentDataSourceName: EnrollmentDataSource;
  limit?: number;
  preference?: BillingDataSource;
  utilityId: number;
  communitySolarProjectGroupId?: number;
}

export interface FetchBillingExperienceOptionsResponse {
  billingExperienceOptions: BillingDataSource[];
}
